import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllContact() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByReportingUser`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllContactPagination(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByReportingUser?page=${page}&limit=${limit}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllContactSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByReportingUser?search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllContactPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByReportingUser?page=${page}&limit=${limit}&search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllContactByDep() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllContactPaginationByDep(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByCompany?page=${page}&limit=${limit}`, { headers });
        return response.data.items
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllContactSearchByDep(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByCompany?search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllContactPaginationSearchByDep(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllContactsByCompany?page=${page}&limit=${limit}&search=${search}`, { headers });
        return response.data.items
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllContactByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCompanyContacts`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchContactDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByContactId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchContactByAccount(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllContactsByAccount/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchContactByDeal(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllContactByDeal/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ContactScoreData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchContactScoreByContactId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ContactConnectioncheck(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/findContactConnections`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ContactMergerUpadet(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateContactsInMerge/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function mergeContactDelte(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteContactInMerge`, { headers, data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massUpdateContact(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/massUpdateContact`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massDeleteContact(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/massDeleteContact`, { headers, data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createContacts(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createContacts`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateContacts(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateContacts/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findContactByContactMail(email, companyId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findContactByContactMail/${email}/${companyId}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    findContactByContactMail,
    massDeleteContact,
    massUpdateContact,
    FetchContactDetails,
    FetchContactByAccount,
    FetchContactByDeal,
    ContactScoreData,
    FetchAllContactByCompany,
    ContactConnectioncheck,
    mergeContactDelte,
    ContactMergerUpadet,
    FetchAllContact,
    AllContactPagination,
    AllContactPaginationSearch,
    FetchAllContactSearch,
    FetchAllContactByDep,
    AllContactPaginationByDep,
    AllContactPaginationSearchByDep,
    FetchAllContactSearchByDep,
    createContacts,
    updateContacts,
}